import api from '../utils/api';

export const fetchCountyAnalysis = async (startYear) => {
  const response = await api.get('/analysis/county', {
    params: { startYear }
  });
  return response.data;
};
/**
 * Fetches granular sub-stream data for a specific revenue stream within a sub-county
 * @param {string|number} subCountyId - The ID of the selected sub-county
 * @param {string} streamName - The parent revenue stream (e.g., 'Parking')
 * @param {number} startYear - The start year of the financial cycle (e.g., 2025)
 */
export const fetchSubStreamDetails = async (subCountyId, streamName, startYear) => {
  try {
    const response = await api.get('/analysis/substreams', {
      params: { 
        subCountyId, 
        streamName, 
        startYear 
      }
    });
    return response.data; // Expected: Array of { rev_sub_stream: string, amount: number }
  } catch (error) {
    console.error(`Error fetching sub-stream details for ${streamName}:`, error);
    throw error;
  }
};
export const fetchSubCountyAnalysis = async (startYear, subCountyId) => {
  const response = await api.get('/analysis/subcounty', {
    params: { startYear, subCountyId }
  });
  return response.data;
}